// import { min, max } from 'd3-array';
import { bandAxis, linearAxis } from '../../../factory/axes';
import data from './data/data.json';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: 25,
    right: isMobile ? 20 : 20,
    bottom: 20,
    left: 20,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;
  // const padding = 0.15;
  const padding = 0.1;

  // const maxValue = max(data, d => d.amt);
  // const minValue = min(data, d => d.amt);

  const xAxisConfig = {
    orientation: 'bottom',
    range: [0, width],
    domain: data.map(d => d.label),
    padding,
  };

  const yAxisConfig = {
    orientation: 'left',
    range: [height, 0],
    domain: [0, 7000000],
    nice: false,
  };

  const { axis: xAxis, scale: x } = bandAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  return {
    data,
    initialWidth,
    initialHeight,
    width,
    height,
    x,
    y,
    xAxis,
    yAxis,
    margins,
  };
}
